import { Injectable } from '@angular/core';
import { UrlMs } from '@environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class InversionesService {
    
    private filtrosHistorico:any;

    constructor(private readonly http: HttpClient) { }

    setFiltrosHistorico(data){
        this.filtrosHistorico=data;
    }

    getFiltrosHistorico(){
        return this.filtrosHistorico;
    }

    public async obtenerInversiones(params): Promise<any> {
        const endpoint = `${UrlMs}/inversion-fondos-mutuos/listar-inversiones`;
        return await this.http.get(endpoint, { params }).toPromise()
            .then((data: any) => {
                return data.data;
            });
    }

    public async obtenerDetalleInversion(id): Promise<any> {
        const endpoint = `${UrlMs}/inversion-fondos-mutuos/listar-inversiones/${id}`;
        return await this.http.get(endpoint).toPromise()
            .then((data: any) => {
                return data.data;
            });
    }
}

export const ESTADOS = [
    { "code": "INGRESADA", "label": "Ingresada", "class": "processing" },
    { "code": "APROBADA", "label": "Aprobada", "class": "done" },
    { "code": "RECHAZADA", "label": "Rechazada", "class": "rejected" }
];

export const PREVISIONES=['APV','NOAPV'];

export const TIPOSPAGO={
    'CHEQUE':'Cheque',
    'TRANSFERENCIA-BANCARIA':'Transferencia',
    'VALE-VISTA':'Vale Vista',
    'CUENTA-INVERSION':'Cuenta de Inversión'
};

export const AUTORIZACIONES={
    'CONFIRMACION_SURAPASS':'Sura Pass',
    'DOCUMENTO':'Documento'
}

export const MENSAJES_ADVERTENCIA_INVERSION = {
    'DEFAULT':'Recuerda que esta transacción es revisada por el equipo de Operaciones Corredora de Bolsa.'
}
